export default __webpack_public_path__ + "assets/front/scss/user-profile.749dff538ce659cc952677e28770384e.css";